/**
 * Created by Kamil on 23.05.2017.
 */
import React, {Component} from 'react';
import MoreSection from "./MoreSection";
import axios from 'axios';
import './ProductCard.css';

class ProductCard extends Component {
    constructor(props) {
        super(props);
        this.state = {imageObject: []};
    }

    componentDidMount() {
        var _this = this;
        if (window.devMode) {
            _this.setState({
                imageObject: window.featured_media
            });
        } else {
            console.log('props');
            console.log(_this.props.product.featured_media);
            this.serverRequest =
                axios
                    .get('/wp-json/wp/v2/media/' + _this.props.product.featured_media)
                    .then(function (result) {
                        console.log('result');
                        console.log(result);
                        _this.setState({
                            imageObject: result.data
                        });
                    });
        }
    }

    render() {
        var imgSrc = '';
        if (this.state.imageObject.hasOwnProperty('media_details') && this.state.imageObject.media_details.hasOwnProperty('sizes')) {
            if(this.state.imageObject.media_details.sizes.hasOwnProperty('medium')) {
                imgSrc = this.state.imageObject.media_details.sizes.medium.source_url;
            } else {
                imgSrc = this.state.imageObject.source_url;
            }
        }

        return (
            <div className="ProductCard col-12">
                <div className="ProductCard-wrap row">
                    <div className="ProductCard-header d-inline-block col-3">
                        <img src={imgSrc} alt="logo"/>
                    </div>
                    <div className="ProductCard-summary d-inline-block col-9">
                        <div className="ProductCard-content">
                            <h2>{this.props.product.title.rendered}</h2>
                            <p className="ProductCard-desc">
                                {this.props.product.excerpt.rendered}
                            </p>
                        </div>
                        <MoreSection datasheetURL={this.props.product.product_meta.datasheet}
                                     link={this.props.product.link}/>
                    </div>
                </div>
            </div>
        );
    }
}

export default ProductCard;


// WEBPACK FOOTER //
// ./src/components/ProductCard.js